import React from "react";
import TemplateComponent from "../../containers/template_page/template_component/template_component";

class CourseDetail extends TemplateComponent {

    componentRender(data) {
        return (
            data ? <div/> : <div className='course-detail'>
                    <div className="box-course course-details">
                        {data.course_type &&
                        <p className="category-type">{data.course_type}</p>
                        }
                        {data.course_attribute &&
                        <p className="language-txt">
                            {data.course_attribute}
                            <span><img src="/english.svg" alt="english"/></span>
                        </p>
                        }
                    </div>
                </div>
        )
    }
}

export default CourseDetail;

